var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "navbar py-0",
      class: { isCheckout: _vm.isCheckout },
      attrs: { fluid: "" }
    },
    [_c("MainHeader", { attrs: { isCheckout: _vm.isCheckout } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }